import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiArrowLeft, FiEdit2, FiList, FiFileText } from 'react-icons/fi';

const PanipuravthaReportDashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { grampanchayatName, arthikVarshLabel } = location.state || {}; // Assuming passed state

    const reportItems = [
        {
            title: "नमुना नं. ९",
            icon: <FiEdit2 className="w-8 h-8 md:w-10 md:h-10 text-white" />,
            path: "/panipuravtha/namuna-9",
            description: "मागणी व वसुली रजिस्टर",
            color: "from-blue-500 to-cyan-500"
        },
        {
            title: "नमुना नं. ९ क",
            icon: <FiEdit2 className="w-8 h-8 md:w-10 md:h-10 text-white" />,
            path: "/panipuravtha/namuna-9k",
            description: "पाणीपट्टी पावती",
            color: "from-emerald-500 to-teal-500"
        },
        {
            title: "नमुना नं. १०",
            icon: <FiEdit2 className="w-8 h-8 md:w-10 md:h-10 text-white" />,
            path: "/panipuravtha/namuna-10",
            description: "कर मागणी बिल",
            color: "from-orange-500 to-amber-500"
        },
        {
            title: "कर वसुलीची पोटकिर्द",
            icon: <FiList className="w-8 h-8 md:w-10 md:h-10 text-white" />,
            path: "/panipuravtha/collection-potkird",
            description: "दैनंदिन कर वसुली",
            color: "from-purple-500 to-indigo-500"
        },
        {
            title: "कर नोटीस",
            icon: <FiFileText className="w-8 h-8 md:w-10 md:h-10 text-white" />,
            path: "/panipuravtha/tax-notice",
            description: "थकबाकी नोटीस",
            color: "from-red-500 to-rose-500"
        },
        {
            title: "थकबाकीदार यादी",
            icon: <FiList className="w-8 h-8 md:w-10 md:h-10 text-white" />,
            path: "/panipuravtha/thakbakidar",
            description: "थकबाकीदार यादी अहवाल",
            color: "from-pink-500 to-fuchsia-500"
        },
        {
            title: "पाणिपुरवठा माहिती सुविधा",
            icon: <FiList className="w-8 h-8 md:w-10 md:h-10 text-white" />,
            path: "/panipuravtha/info-service",
            description: "ग्राहकांची माहिती सुविधा",
            color: "from-indigo-500 to-blue-500"
        },
        {
            title: "मासिक कर वसुली अहवाल",
            icon: <FiList className="w-8 h-8 md:w-10 md:h-10 text-white" />,
            path: "/panipuravtha/monthly-report",
            description: "महिनावार वसुली अहवाल",
            color: "from-green-500 to-emerald-500"
        },
    ];

    return (
        <div className="min-h-screen bg-gray-50 p-6 md:p-8 font-poppins">
            {/* Header */}
            <div className="max-w-7xl mx-auto mb-10">
                <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-white/50 backdrop-blur-sm"
                        >
                            <FiArrowLeft className="w-6 h-6" />
                        </button>
                        <div>
                            <h1 className="text-2xl md:text-3xl font-bold mb-1">पाणीपुरवठा रिपोर्ट्स</h1>
                            <p className="text-slate-300 text-sm">
                                {grampanchayatName || 'ग्रामपंचायत'} | आर्थिक वर्ष: {arthikVarshLabel || '२०२४-२५'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Grid */}
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {reportItems.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => {
                            if (item.path) {
                                navigate(item.path, { state: location.state });
                            }
                        }}
                        className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-100"
                    >
                        <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
                        <div className="p-6">
                            <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                                {item.icon}
                            </div>
                            <h3 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                                {item.title}
                            </h3>
                            <p className="text-gray-500 text-sm">
                                {item.description}
                            </p>
                        </div>
                        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center">
                            <span className="text-sm font-medium text-gray-600 group-hover:text-blue-600 transition-colors">
                                रिपोर्ट पहा
                            </span>
                            <svg
                                className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transform group-hover:translate-x-1 transition-all duration-300"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PanipuravthaReportDashboard;
